import { createSelector } from '@ngrx/store';
import { getSharedState, SharedState } from '../shared.reducer';

const getShowTags = createSelector(getSharedState, (state: SharedState) => state.showTags.showTags);

export const ShowTagsSelectors = {
    getShowTags
};
